import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Content, Icon, Button, ButtonToolbar, Panel } from 'rsuite';
import { omit } from 'lodash/fp';
import * as PERMISSIONS from '../../../constants/permissions/inventory';
import * as EXPORT_TYPES from '../../../constants/inventory/InventoryExportTypes';
import { modifyAccess, viewAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import InventorySearchLocation from '../../../containers/inventory/Search/Location';
import InventoryLocationList from '../../../containers/inventory/LocationList';
import ExportButton from '../../../containers/inventory/ExportCsvButton';
import { inventoryCreateLocationPath } from '../../Paths';
import { getIsFetching } from '../../../redux/Inventory/selectors/location';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';

export default () => {
  const isFetching = useSelector(getIsFetching);
  const query = useSelector(state =>
    getSearchQueryForContext(state, SEARCH_CONTEXT.LOCATION)
  );
  return (
    <InventoryPageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.LOCATION)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Locations">
          <Panel bordered>
            <ButtonToolbar style={{ float: 'right' }}>
              <AccessControl allowOnlyFor={viewAccess(PERMISSIONS.LOCATION)}>
                {!isFetching && (
                  <ExportButton
                    style={{ marginRight: 5 }}
                    type={EXPORT_TYPES.EXPORT_LOCATIONS}
                    searchQuery={omit(['limit', 'order', 'page'], query)}
                  />
                )}
              </AccessControl>
              <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.LOCATION)}>
                <Link to={inventoryCreateLocationPath}>
                  <Button appearance="primary">
                    <Icon icon="plus-circle" /> Create New
                  </Button>
                </Link>
              </AccessControl>
            </ButtonToolbar>
            <InventorySearchLocation placeholder="Type location and press enter" />
          </Panel>
        </PageHeader>
        <Content>
          <InventoryLocationList />
        </Content>
      </AccessControl>
    </InventoryPageLayout>
  );
};
